import lodash from 'lodash';

import SideNav from 'pages/studyOverview/components/SideNav';
import { TwoColumnScaffold, LeftColumn, RightColumn } from 'pages/studyOverview/components/TwoColumnScaffold';
import { reportLinks } from '../utils/constants';
import styles from './Report.scss';

const Report = (props) => {
    const sideNavLinks = reportLinks;

    return (
        <TwoColumnScaffold className={styles.scaffold}>
            <LeftColumn>
                <SideNav 
                    links={sideNavLinks}
                    location={props.location}
                    activeIndex={() =>
                        lodash.findIndex(
                            sideNavLinks,
                            (link) => props.location.pathname.includes(link.to)
                        )
                    }
                />
            </LeftColumn>
            <RightColumn className={styles.rightColumn}>
                {props.children}
            </RightColumn>
        </TwoColumnScaffold>
    );
};

export default Report;
